export default "__VITE_ASSET__Dh5xsK1$__"